module.exports = __webpack_public_path__ + "static/img/11.340c046b.jpg";